<!--
  Показывает общую ошибку формы: строку без заголовка или массив под заголовком
  «Возникли ошибки». Вариант dark предназначен только для форм на тёмном фоне.
-->
<template>
  <div
    class="base-error-container"
    :class="`base-error-container--${variant}`"
    role="alert"
  >
    <span class="base-error-container__icon" aria-hidden="true">
      <AppIcon name="close" :size="12" />
    </span>

    <div class="base-error-container__content">
      <template v-if="hasMultipleErrors">
        <p class="base-error-container__title">Возникли ошибки</p>
        <ul class="base-error-container__list">
          <li
            v-for="(message, index) in errorContainerMsg.text"
            :key="`${message}-${index}`"
          >
            {{ message }}
          </li>
        </ul>
      </template>

      <p v-else class="base-error-container__text">
        {{ errorContainerMsg.text }}
      </p>
    </div>
  </div>
</template>

<script>
import AppIcon from "@/components/Icon/AppIcon.vue";

export default {
  name: "BaseErrorContainer",

  components: {
    AppIcon,
  },

  props: {
    errorContainerMsg: {
      type: Object,
      required: true,
    },
    variant: {
      type: String,
      default: "light",
      validator: (value) => ["light", "dark"].includes(value),
    },
  },

  computed: {
    hasMultipleErrors() {
      return Array.isArray(this.errorContainerMsg.text);
    },
  },
};
</script>

<style scoped>
.base-error-container {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  box-sizing: border-box;
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #f5c2bc;
  border-radius: 8px;
  background: #fff6f5;
  color: #7a271a;
  overflow-wrap: anywhere;
}

.base-error-container__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 20px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #fde8e6;
  color: #b42318;
}

.base-error-container__content {
  min-width: 0;
}

.base-error-container__title,
.base-error-container__text,
.base-error-container__list {
  margin: 0;
}

.base-error-container__title {
  color: #b42318;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
}

.base-error-container__text {
  font-size: 14px;
  line-height: 20px;
}

.base-error-container__list {
  padding-left: 18px;
  margin-top: 3px;
  font-size: 13px;
  line-height: 1.5;
}

.base-error-container__list > li {
  display: list-item;
  list-style-type: disc;
}

.base-error-container--dark {
  border-color: rgba(248, 113, 113, 0.35);
  background: rgba(248, 113, 113, 0.1);
  color: #fecaca;
}

.base-error-container--dark .base-error-container__icon {
  background: rgba(248, 113, 113, 0.22);
  color: #fca5a5;
}

.base-error-container--dark .base-error-container__title {
  color: #fca5a5;
}
</style>
